
import moment from 'moment'
import objectPath from 'object-path'

const getters = {
  getExcursions: state => state.excursions,
  getExcursion: state => excursionId => state.excursions[excursionId].excursions,
  getExcursionsSelected: state => excursionId => state.excursions[excursionId].selected,
  getExcursionForm: state => excursionId => state.excursions[excursionId].form,
  // eslint-disable-next-line
  getExcursionFormForSearch: (state, getters) => excursionId => {
    const {
      city: { slug: cityId },
      ...form
    } = getters.getExcursionForm(excursionId)

    const {
      adults,
      children
    } = getters.getNumberOfTourists

    const currency = getters.getCartPrice.currency

    return {
      ...form,
      cityId,
      adults,
      children,
      currency
    }
  },
  getExcursionDetails: state => excursionId => state.excursions[excursionId].details,
  getExcursionPenaltiesData: state => ({ excursionIndex, index }) => {
    const {
      current,
      prices,
      priceIndex
    } = state.excursions[excursionIndex].selected[index]
    const { searchId } = state.excursions[excursionIndex].excursions
    const selectedPrice = prices[priceIndex]
    const { from, price: { currency } } = selectedPrice

    return {
      excursionSearchId: searchId,
      excursionId: current.slug,
      date: moment.unix(from).format('DD.MM.YYYY'),
      time: moment.unix(from).format('HH:mm'),
      currency
    }
  },
  getExcursionSelectedCurrent: state => target => objectPath.get(state, target).current.slug,
  getExcursionSelectedPriceIndex: state => target => objectPath.get(state, target),
}

export default getters